import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

const StatusBreakdown = ({ statusBreakdown, onStatusClick }) => {
    if (!statusBreakdown) return null;

    const statusColors = {
        incomplete: '#ffc107',
        complete: '#28a745',
        pending_review: '#fd7e14',
        in_review: '#17a2b8',
        approved: '#007bff',
        rejected: '#dc3545'
    };

    const statusLabels = {
        incomplete: 'Incomplete',
        complete: 'Complete',
        pending_review: 'Pending Review',
        in_review: 'In Review',
        approved: 'Approved',
        rejected: 'Rejected'
    };

    const chartData = {
        labels: Object.keys(statusBreakdown)
            .filter(key => !key.includes('percentage'))
            .map(key => statusLabels[key]),
        datasets: [
            {
                data: Object.keys(statusBreakdown)
                    .filter(key => !key.includes('percentage'))
                    .map(key => statusBreakdown[key]),
                backgroundColor: Object.keys(statusBreakdown)
                    .filter(key => !key.includes('percentage'))
                    .map(key => statusColors[key]),
                borderColor: Object.keys(statusBreakdown)
                    .filter(key => !key.includes('percentage'))
                    .map(key => statusColors[key]),
                borderWidth: 2,
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'bottom',
            },
            tooltip: {
                callbacks: {
                    label: function(context) {
                        const label = context.label || '';
                        const value = context.parsed;
                        const total = context.dataset.data.reduce((a, b) => a + b, 0);
                        const percentage = ((value / total) * 100).toFixed(1);
                        return `${label}: ${value} (${percentage}%)`;
                    }
                }
            }
        },
        onClick: (event, elements) => {
            if (elements.length > 0) {
                const index = elements[0].index;
                const statusKeys = Object.keys(statusBreakdown).filter(key => !key.includes('percentage'));
                const status = statusKeys[index];
                if (onStatusClick) {
                    onStatusClick(status);
                }
            }
        },
        onResize: (chart) => {
            chart.resize();
        }
    };

    return (
        <div className="card">
            <div className="card-header">
                <h3 className="card-title">
                    <i className="fas fa-chart-pie mr-2"></i>
                    Status Breakdown
                </h3>
                <div className="card-tools">
                    <button 
                        type="button" 
                        className="btn btn-tool" 
                        onClick={() => onStatusClick && onStatusClick('')}
                    >
                        <i className="fas fa-times"></i>
                    </button>
                </div>
            </div>
            <div className="card-body">
                <div style={{ position: 'relative', height: '269px' }}>
                    <Pie data={chartData} options={options} />
                </div>
                
                {/* Status Legend */}
                <div className="row mt-3">
                    {Object.keys(statusBreakdown)
                        .filter(key => !key.includes('percentage'))
                        .map((status, index) => (
                            <div key={status} className="col-md-6 mb-2">
                                <div className="d-flex align-items-center">
                                    <div 
                                        className="status-indicator mr-2"
                                        style={{
                                            width: '12px',
                                            height: '12px',
                                            backgroundColor: statusColors[status],
                                            borderRadius: '50%'
                                        }}
                                    ></div>
                                    <span className="text-sm">
                                        {statusLabels[status]}: {statusBreakdown[status]}
                                    </span>
                                    <span className="text-muted ml-1">
                                        ({statusBreakdown[`${status}_percentage`]}%)
                                    </span>
                                </div>
                            </div>
                        ))}
                </div>
            </div>
        </div>
    );
};

export default StatusBreakdown; 